var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserIe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M11.7564 10.5466C11.2178 11.5228 10.1825 12.1837 8.99362 12.1837C7.24978 12.1837 5.83613 10.7626 5.83613 9.00931H10.5825H12.1509H15.9562C15.9852 8.74863 16.0002 8.48364 16.0002 8.21534C16 4.26426 12.7833 1.06122 8.81547 1.06122C4.8474 1.06122 1.63074 4.26426 1.63074 8.21514C1.63074 12.166 4.8474 15.3691 8.81547 15.3691C11.9637 15.3691 14.639 13.3528 15.6098 10.5464H11.7564V10.5466ZM8.85307 4.25973C10.5192 4.25973 11.87 5.5666 11.87 7.17882H5.83613C5.83613 5.5666 7.1869 4.25973 8.85307 4.25973Z",
    fill: "url(#paint0_radial_ie)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    d: "M5.07545 14.382C3.49029 15.1032 2.19213 15.2279 1.54536 14.5821C0.221463 13.2609 2.1205 9.22321 5.78712 5.56383C9.45375 1.90445 13.4994 0.00893302 14.8233 1.33022C15.3882 1.89427 15.3646 2.95388 14.8683 4.26684C14.9411 4.37928 15.0106 4.49334 15.0771 4.60971C15.7434 2.87522 15.736 1.40009 14.8597 0.525554C13.5013 -0.830201 8.34451 0.430698 4.38487 4.38252C0.425229 8.33433 -0.82333 13.4952 0.520274 14.8364C1.5442 15.8583 3.40313 15.6827 5.53699 14.6354C5.37982 14.5562 5.2259 14.4716 5.07545 14.382Z",
    fill: "#FECD09"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_ie",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.472965 8.60042) scale(16.4732 12.1599)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.654757,
    stopColor: "#3DC5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D80E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIe);
export default __webpack_public_path__ + "static/media/browser-ie.045561d94953e2651323ccec5fefe301.svg";
export { ForwardRef as ReactComponent };